export function getReceiptYear(order) {
  const date = order?.ReceiptDate || order?.CreatedAt || "";

  if (/^\d{4}/.test(String(date))) {
    return String(date).slice(0, 4);
  }

  return String(new Date().getFullYear());
}

export function formatReceiptNumber(order) {
  const id = order?.Id ?? order?.id ?? 0;
  const year = getReceiptYear(order);
  const sequence = String(id).padStart(6, "0");

  return `GW-REC-${year}-${sequence}`;
}

export function formatOrderTotal(totalCents) {
  const amount = Number(totalCents || 0) / 100;
  return `$${amount.toFixed(2)} USD`;
}

export function getOrderStatusClass(status) {
  const value = String(status || "").toLowerCase();

  if (/(paid|complete|success|approved)/i.test(value)) {
    return "order-card__status--success";
  }

  if (/(pending|process|waiting)/i.test(value)) {
    return "order-card__status--pending";
  }

  if (/(cancel|fail|reject|error)/i.test(value)) {
    return "order-card__status--danger";
  }

  return "order-card__status--default";
}
